var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cs-button',{attrs:{"type":"danger","icon":"delete","icon-type":"material"},on:{"click":_vm.deleteTimeoff}},[_vm._v(" "+_vm._s(_vm.$t('commons.delete'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }